import { Component, Inject, Input, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
})
export class ConfirmationComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit(): void {}


   sortObjectKeysByArray(obj: any, order: string[]): any {
    const sorted: any = {};
    order.forEach((key) => {
      if (obj.hasOwnProperty(key)) {
        sorted[key] = obj[key]; // Add the key-value pair to the new object
      }
    });
    for (const key in obj) {
      if (!sorted.hasOwnProperty(key)) {
        sorted[key] = obj[key];
      }
    }

    return sorted;
  }

  getObjectKeys(obj: any): { key: string, value: any }[] {
    try {
      obj = JSON.parse(obj);
      if (obj == null) return  [];
      obj = this.sortObjectKeysByArray(obj,this.data.keys);
      return Object.keys(obj).map(key => ({ key, value: obj[key] }));
    } catch (e){return  [];}

  }
}
